import * as React from 'react';
import { useSelector } from 'react-redux';

import { Carousel } from '../../components/Carousel';
import { getNewbuildingId, getBackgroundVideo, getMedia } from '../../selectors/newbuilding';
import { BasicContainer } from '../Basic';

export function CarouselContainer() {
  const newbuildingId = useSelector(getNewbuildingId);
  const backgroundVideo = useSelector(getBackgroundVideo);
  const media = useSelector(getMedia);

  return <Carousel JKid={newbuildingId} backgroundVideo={backgroundVideo} media={media} basic={<BasicContainer />} />;
}
